import React, { useEffect, useRef, useState } from "react";
import "./ocr-file-preview-uploader.scss";
import { useTranslation } from "react-i18next";
import CloudUploadTrukker from "./../../assets/images/uploadIcon.svg";
import CloudUploadAdeed from "./../../assets/adeed/images/uploadIcon.svg";
import {
  DeleteFilled,
  DownloadOutlined,
  UploadOutlined,
} from "@ant-design/icons";

import {
  List,
  Typography,
  Button,
  Popconfirm,
  Space,
  message,
  Modal,
} from "antd";
import { getThumbnailImagePath } from "../../util/documentThumbUtility";
import Preview from "../preview/preview";
import { isAdeed } from "../../constants/brand";

// ADEED Freight shows its blue copies of these images (src/assets/adeed).
const CloudUpload = isAdeed ? CloudUploadAdeed : CloudUploadTrukker;
// import { useState } from "react";
const { Text } = Typography;

const OCRFilePreviewUploader = (props) => {
  console.log(" props", props);
  const { t } = useTranslation();
  const fileuploadref = useRef(null);
  const [uploadedFileThumb, setUploadedFileThumb] = useState(
    getThumbnailImagePath(props?.defaultThumbFile) || ""
  );

  console.log("OCRFilePreviewUploader uploadedFileThumb", uploadedFileThumb);
  const [uploadedFile, setUploadedFile] = useState(
    props?.defaultFile ? props?.defaultFile : ""
  );
  const [isDragActive, setIsDragActive] = useState(false);

  const [isPreviewModalOpen, setIsPreviewModalOpen] = useState(false);

  // useEffect(() => {
  //   if (props?.defaultThumbFile) {
  //     setUploadedFileThumb(getThumbnailImagePath(props.defaultThumbFile));
  //   } else {
  //   setUploadedFileThumb(null);
  // }
  // }, [props?.defaultThumbFile]);

  useEffect(() => {
    if (props?.defaultThumbFile) {
      setUploadedFileThumb(getThumbnailImagePath(props.defaultThumbFile));
    } else {
      setUploadedFileThumb(null);
    }

    if (props?.defaultFile) {
      setUploadedFile(props.defaultFile);
    } else {
      setUploadedFile(null);
    }
  }, [props?.defaultThumbFile, props?.defaultFile]);

  // Preview Image modal
  const previewImage = () => {
    setIsPreviewModalOpen(true);
  };
  const handleModalCancel = () => {
    setIsPreviewModalOpen(false);
  };

  const handleUploadClick = () => {
    if (!props.readonly) {
      if (fileuploadref.current) {
        fileuploadref.current.click();
      } else {
        console.error("File input ref is not set.");
      }
    }
  };

  const MAX_FILES = 5;
  const handleFileChange = (fileEvent) => {
    const files = fileEvent?.target?.files;

    if (files && files.length > 0) {
      // 1. Check for max file count
      if (files.length > MAX_FILES) {
        Notification.error(`You can upload a maximum of ${MAX_FILES} files.`);
        fileEvent.target.value = null; // Reset input
        return;
      }

      // 2. Check for unsupported file types
      const unsupportedFiles = Array.from(files).filter((file) => {
        return !(
          file.type === "image/png" ||
          file.type === "image/jpg" ||
          file.type === "image/jpeg" ||
          file.type === "application/pdf"
        );
      });

      if (unsupportedFiles.length > 0) {
        const names = unsupportedFiles.map((file) => file.name).join(", ");
        message.error(`Upload failed. Unsupported files: ${names}`);
        fileEvent.target.value = null;
        return;
      }

      // 3. Proceed Only with Supported  files
      const validFiles = [];
      for (let i = 0; i < files.length; i++) {
        const file = files[i];
        const result = uploadFile(file);
        if (result) validFiles.push(result);
      }

      // Call props.onChange with all valid files
      if (validFiles.length > 0) {
        props.onChange(validFiles);
      }
    }
  };

  const uploadFile = (file) => {
    const allowedTypes = [
      "image/png",
      "image/jpg",
      "image/jpeg",
      "application/pdf",
    ];

    if (!allowedTypes.includes(file.type)) {
      Notification.error(t("FILE_UPLOAD_NOT_SUPPORTED"));
      return null;
    }

    if (file.size >= 10 * 1024 * 1024) {
      Notification.error(t("FILE_SIZE_ERROR"));
      return null;
    }

    // Return file metadata or actual file depending on need
    return {
      file,
      // fileName: file.name,
      // fileType: file.type,
      // fileSize: file.size,
      // docType: props?.filetype,
      // entityType: props?.entityType,
    };
  };

  return (
    <>
      {props.showDownload && uploadedFile && (
        <div
          style={{ cursor: "pointer", textAlign: "right", zIndex: 1 }}
          onClick={() => window.open(uploadedFile, "_blank")}
        >
          <Button
            size="small"
            type="default"
            icon={<DownloadOutlined />}
          ></Button>
        </div>
      )}
      {/* NEW FILE UPLOAD  */}
      {!uploadedFileThumb && (
        <div
          className="ocr-file-preview-upload-wrapper"
          onClick={handleUploadClick}
        >
          <div
            style={{
              display: "flex",
              gap: "5px",
              justifyContent: "center",
              width: "100%",
              alignItems: "center",
              padding: props?.accessFile && "10px 0",
            }}
          >
            <img src={CloudUpload} alt="Cloud Upload" />
            <span className="upload-text">
              <Text
                className="upload-text"
                ellipsis={{ tooltip: true }}
                style={{ fontWeight: 500, fontSize: "14px" }}
              >
                {!props?.accessFile
                  ? `${t("KYC_CLICK_TO_UPLOAD")}`
                  : props?.name
                  ? `${t("KYC_UPLOAD_LBL")} ${props?.name}`
                  : `${t("KYC_UPLOAD_LBL")}`}
              </Text>
              {/* {t("KYC_DRAG_DROP")} */}
            </span>
          </div>
          {
            <span
              className="file-size"
              style={{ margin: "0 auto", fontSize: "10px", lineHeight: "1.56" }}
            >
              {t("KYC_ONLY")} PNG, JPG, JPEG, PDF ({t("KYC_MAX_SIZE")} - 10MB)
            </span>
          }
          <input
            type="file"
            onChange={handleFileChange}
            ref={fileuploadref}
            style={{ display: "none" }}
            accept=".png,.jpg,.jpeg,.pdf"
          />
        </div>
      )}

      {/* FILE UPLOADED AND DEFAULT FILE  */}
      {uploadedFileThumb && (
        <div
          style={{
            position: "relative",
            padding: "10px",
            cursor: "default",
            alignItems: "center",
            display: "flex",
          }}
          className="ocr-file-preview-upload-wrapper existing-file-preview"
        >
          <img
            className="uploaded-file"
            src={uploadedFileThumb}
            onClick={previewImage}
            style={{
              cursor: "zoom-in",
              width: props.delete === false ? "100%" : "80%",
            }}
          />
          {/* <Row className='uploaded-file-row'>
                                        {fileName &&
                                            <span>{fileName}</span>
                                        }
                                </Row> */}
          {!props.readonly ? (
            <div
              className={
                props.reUpload ? "icon-container" : "icon-container-center"
              }
            >
              {/* {!props.reUpload &&  */}
              {props.delete === false ? (
                ""
              ) : (
                <DeleteFilled
                  // onClick={deleteFile}
                  onClick={props.onDelete}
                  className="delete-icon"
                />
              )}
              {props.reUpload && (
                <div
                  onClick={handleUploadClick}
                  className={isDragActive ? "drag-active" : "content"}
                  style={{ padding: !props?.accessFile && "25px 10px" }}
                  // onDragOver={(e) => {
                  //   handleUploadDragOver(e);
                  // }}
                  // onDragExit={(e) => {
                  //   handleUploadDragEnd(e);
                  // }}
                  // onDrop={(e) => {
                  //   handleUploadDrop(e);
                  // }}
                >
                  <UploadOutlined className="reupload-icon" />
                  <input
                    type="file"
                    // onChange={handleFileChange}
                    ref={fileuploadref}
                    style={{ display: "none" }}
                  />
                </div>
              )}
              {/* <DownloadOutlined onClicks={downloadFile} className="download-icon"></DownloadOutlined> */}
            </div>
          ) : null}
        </div>
      )}

      <Modal
        title="Preview"
        open={isPreviewModalOpen}
        onCancel={handleModalCancel}
        centered
        footer={null}
        className="big-modal"
        style={{ width: "90%" }}
      >
        <Preview uploadedfile={uploadedFile}></Preview>
      </Modal>
    </>
  );
};

export default OCRFilePreviewUploader;
